<template>
    <el-table :data="data" class="b-table" @selection-change="handleSelectionChange" fit highlight-current-row style="width: 100%;" height="100%" size="mini" stripe border v-if="showColumns && showColumns.length > 0">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <template v-for="field in showColumns">
            <template v-if="field.showInList">
                <template v-if="field.widgetType == Constants.DataDic.WidgetType.YesOrNo">
                    <el-table-column :key="field.name" :label="field.label" :width="getColumnWidth(field.name)" align="center">
                        <template slot-scope="{ row }">
                            <el-tag size="mini" type="danger" effect="dark" v-if="row[field.name] == false">否</el-tag>
                            <el-tag size="mini" type="success" effect="dark" v-if="row[field.name] == true">是</el-tag>
                        </template>
                    </el-table-column>
                </template>
                <template v-else-if="field.widgetType == Constants.DataDic.WidgetType.SingleImageUpload">
                    <el-table-column :key="field.name" :label="field.label" :width="getColumnWidth(field.name)">
                        <template slot-scope="{ row }">
                            <img :src="`/api/storage/resource/fileDownload?unique=${row[field.name]}&isAttachement=false`" />
                        </template>
                    </el-table-column>
                </template>
                <template v-else-if="field.classCode && field.widgetType == Constants.DataDic.WidgetType.Cascader">
                    <el-table-column :key="field.name" :label="field.label" :width="getColumnWidth(field.name, '160px')" align="center">
                        <template slot-scope="{ row }">
                            {{getClassCodeOptionsValue(field, row)}}
                        </template>
                    </el-table-column>
                </template>
                <template v-else-if="field.widgetType == Constants.DataDic.WidgetType.DateTime">
                    <el-table-column :key="field.name" :label="field.label" :width="getColumnWidth(field.name, '160px')" align="center">
                        <template slot-scope="{ row }">
                            {{Utils.formatDate(row[field.name], 'YYYY-MM-dd hh:mm:ss')}}
                        </template>
                    </el-table-column>
                </template>
                <template v-else-if="field.widgetType == Constants.DataDic.WidgetType.Date">
                    <el-table-column :key="field.name" :label="field.label" :width="getColumnWidth(field.name, '100px')" align="center">
                        <template slot-scope="{ row }">
                            {{Utils.formatDate(row[field.name], 'YYYY-MM-dd')}}
                        </template>
                    </el-table-column>
                </template>
                <template v-else-if="field.widgetType == Constants.DataDic.WidgetType.Time">
                    <el-table-column :key="field.name" :label="field.label" :width="getColumnWidth(field.name, '100px')" align="center">
                        <template slot-scope="{ row }">
                            {{Utils.formatDate(row[field.name], 'hh:mm:ss')}}
                        </template>
                    </el-table-column>
                </template>
                <template v-else-if="field.code && field.options && field.options.length > 0">
                    <el-table-column :key="field.name" :label="field.label" :width="getColumnWidth(field.name, '90px')" align="center">
                        <template slot-scope="{ row }">
                            {{getCodeOptionsValue(field, row)}}
                        </template>
                    </el-table-column>
                </template>
                <template v-else>
                    <el-table-column :key="field.name" :label="field.label" :width="getColumnWidth(field.name, field.widgetType == Constants.DataDic.WidgetType.Number ? '90' : '')">
                        <template slot-scope="{ row }">
                            <template v-if="field.isUnionColumn === true">
                                {{getUnionColumnValue(field, row)}}
                            </template>
                            <template v-else>
                                {{row[field.name]}}
                            </template>
                        </template>
                    </el-table-column>
                </template>
            </template>
        </template>
        <el-table-column label="操作" width="100px" fixed="right" align="center" v-if="showOperationColumn">
            <template slot-scope="{ row , index }">
                <slot name="operation" :item="row" :index="index"></slot>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
import DatadicAPI from "@/web-framework/api/datadic.js";
export default {
    name: "TableInfoList",
    props: {
        // 必填props
        name: {
            type: String,
            required: true
        },
        data: {
            type: Array,
            required: true
        },
        showOperationColumn: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    data() {
        return {
            serviceName: '',
            datadicName: '',
            datadicInfo: '',
            showColumns: [],
        }
    },
    mounted() {
        let p = this.name.split('/');
        this.serviceName = p[1];
        this.datadicName = p[2];
        this.loadDatadic();
    },
    methods: {
        loadDatadic() {
            this.$store.dispatch("cache/getDatadic", { serviceName: this.serviceName, datadicName: this.datadicName }).then(result => {
                if (result) {
                    this.datadicInfo = result;
                    this.makeShownColumns();
                }
            });
        },
        makeShownColumns() {
            if (this.datadicInfo && this.datadicInfo.fields) {
                if (!this.columns || this.columns.length == 0) {
                    this.datadicInfo.fields.forEach(item => {
                        // 列表的列
                        if (item.showInList) {
                            this.showColumns.push(item);
                        }
                    });
                } else {
                    let map = this.Utils.list2map(this.datadicInfo.fields, 'name');
                    this.columns.forEach(item => {
                        let key = this.Utils.isString(item) ? item : item.key;
                        if (map[key]) {
                            this.showColumns.push(map[key]);
                        } else if (key.indexOf('/') != -1) {
                            let multi = key.split('/');
                            let p = [];
                            for (let i = 0; i < multi.length; i++) {
                                p.push(map[multi[i]].label);
                            }
                            let unionField = this.createUnionField(key, p.join('/'));
                            unionField.isUnionColumn = true;
                            unionField.unionColumn = multi;
                            unionField.showInList = true;
                            this.showColumns.push(unionField);
                        }
                    });
                }
            }
        },
        handleSelectionChange(val) {
            this.$emit('onSelect', val);
        },
        getCodeOptionsValue(field, row) {
            for (let i = 0; i < field.options.length; i++) {
                if (field.options[i].value == new String(row[field.name])) {
                    return field.options[i].name;
                } else if ((field.options[i].value == '1' && row[field.name] === true) || (field.options[i].value == '0' && row[field.name] === false)) {
                    return field.options[i].name;
                }
            }
            return '';
        },
        getClassCodeOptionsValue(field, row) {
            let item = this.Utils.getItemInTree(field.options, 'children', 'code', row[field.name]);
            if (item) {
                return item.name;
            }
        },

        // 获取列的宽度
        getColumnWidth(name, defaultValue) {
            if (this.columns && this.columns.length > 0) {
                for (let i = 0; i < this.columns.length; i++) {
                    if (!this.Utils.isString(this.columns[i]) && this.columns[i].key && this.columns[i].key == name) {
                        return this.columns[i].width;
                    }
                }
            }
            return this.Utils.isNull(defaultValue) ? 'auto' : defaultValue;
        }
    }
}
</script>